<template>
  <Modal
    actions
    name="DELETE_ALL_APPOINTMENT_FILES"
    :title="$t('appointment.label.deleteAllFiles')"
  >
    <template v-slot:body>
      <h3 class="red--text">
        {{ $t('upload.delete.title') }}
      </h3>
      <p>
        {{ $t('upload.delete.deleteAll') }}
      </p>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isAppointmentFilesDeleting"
        elevation="0"
        color="grey darken-1"
        text
      >
        {{ $t('deleteModal.buttons.cancel') }}
      </v-btn>
      <v-btn
        @click="deleteAllFiles"
        :loading="isAppointmentFilesDeleting"
        elevation="0"
        class="ml-5"
        color="red"
        dark
      >
        {{ $t('deleteModal.buttons.deleteAllFiles') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Modal from '@/components/app/Modal'

export default {
  name: 'ModalAppointmentDeleteAllFiles',

  props: {
    handleDelete: {
      type: Function,
      required: false,
    },
  },

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['appointmentFiles', 'isAppointmentFilesDeleting']),
  },

  methods: {
    ...mapMutations(['closeAllModals', 'setAppointmentFilesToDelete']),

    deleteAllFiles() {
      Promise.resolve(this.appointmentFiles)
        .then((files) => {
          this.setAppointmentFilesToDelete(files)
        })
        .then(() => {
          this.handleDelete()
        })
    },
  },
}
</script>
